"use client";

import { useEffect } from "react";
import { nextJsReportWebVitals } from "../observability";

export default function WebVitals() {
  useEffect(() => {
    // For App Router, we need to manually track web vitals
    if (typeof window === "undefined") return;

    // Import web-vitals library dynamically to avoid SSR issues
    import("web-vitals")
      .then(({ onCLS, onFCP, onLCP, onTTFB, onINP }) => {
        onCLS((metric) =>
          nextJsReportWebVitals({
            ...metric,
            startTime: metric.value,
            label: "web-vital",
          }),
        );
        onFCP((metric) =>
          nextJsReportWebVitals({
            ...metric,
            startTime: metric.value,
            label: "web-vital",
          }),
        );
        onLCP((metric) =>
          nextJsReportWebVitals({
            ...metric,
            startTime: metric.value,
            label: "web-vital",
          }),
        );
        onTTFB((metric) =>
          nextJsReportWebVitals({
            ...metric,
            startTime: metric.value,
            label: "web-vital",
          }),
        );
        onINP((metric) =>
          nextJsReportWebVitals({
            ...metric,
            startTime: metric.value,
            label: "web-vital",
          }),
        );
      })
      .catch(() => {
        // Silently fail if web-vitals is not available
      });
  }, []);

  return null;
}
